import React from "react";
import "./Contact.css";

const exportform = () => {
    return (
        <>
            <div className="contact-form-contact">
                <div className="export-contact-form">
                    <h3>EXPORT ENQUIRY</h3>
                    <p id="conetct-p-tag-top-form">Fill in the form below or send your requirement directly on <span>export@dasmesh.com</span>and we will provide you the best quote as soon as possible</p>
                    <div className="form-container">
                        <form>
                            <div className="form-row">
                                <div className="form-group">
                                    <input type="text" id="name" name="name" placeholder="Your Name" />
                                </div>
                                <div className="form-group">
                                    <input type="email" id="email" name="email" placeholder="Email Address" />
                                </div>
                            </div>
                            <div className="form-row">
                                <div className="form-group">
                                    <input type="text" id="phone" name="phone" placeholder="Phone No." />
                                </div>
                                <div className="form-group">
                                    <input type="text" id="address" name="address" placeholder="Local Address" />
                                </div>
                            </div>
                            <div className="form-row">
                                <div className="form-group">
                                    <input type="text" id="city" name="city" placeholder="City" />
                                </div>
                                <div className="form-group">
                                    <input type="text" id="state" name="state" placeholder="State/Province" />
                                </div>
                            </div>
                            <div className="form-row">
                                <div className="form-group">
                                    <input type="text" id="country" name="country" placeholder="Country" />
                                </div>
                                <div className="form-group">
                                    <input type="text" id="postal-code" name="postal-code" placeholder="Postal Code" />
                                </div>
                            </div>
                            <div className="form-group">
                                <textarea id="requirement" name="requirement" placeholder="Describe Your Requirement"></textarea>
                            </div>
                            <div className="contact-checkbox-form">
                                <input type="checkbox" />
                                <p>By checking this box, you consent and agree to DASMESH sending text messages or placing voice calls (live or pre-recorded), to the telephone number you have provided, for advertising and telemarketing purposes. You understand that you are not required to sign or enter into this agreement as a condition of purchasing any property, goods, or services. You further accept our privacy policy and Legal Disclaimer. *</p>
                            </div>
                            <span><input type="submit" name="submit" value="Send" /></span>
                        </form>
                    </div>
                </div >
            </div>
        </>


    );
};

export default exportform;